import { IndexableObjectType } from "shared/types/common";
import { Source } from "shared/types/source";
import { Workflow } from "shared/types/workflow";

export const mergeSourcesWithWorkflow = (workflow: Workflow, enclaveMap: IndexableObjectType) => {
  const workflowSources: Source[] = [];

  workflow.sources.forEach((source) => {
    const matchingRawSource = enclaveMap[source.id];

    if (matchingRawSource) {
      workflowSources.push({
        ...matchingRawSource,
        weight: source.weight,
      });
    }
  });

  return {
    ...workflow,
    sources: workflowSources,
  };
}
